import Vue from 'vue';

export default {
    setProfiles(state, profiles) {
        profiles.forEach((item) => {
            Vue.set(state.list, item.userId, item);
        })
    }
}